var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-autocomplete',{attrs:{"value":_vm.value,"open-on-focus":"","disabled":_vm.disabled,"icon":_vm.icon,"data":_vm.filteredDataArray},on:{"input":function($event){return _vm.$emit('input', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }